<template lang="pug">
div(class="text-center overflow-hidden")
    template(v-for="promoImage in pData.promoImages")
        a(v-if="promoImage.url" :href="promoImage.url" :target="urlTarget(promoImage.url)" aria-label="Promo Link")
            img(:src="$getImageUrl(promoImage.image.key, promoImage.image.filename)" alt="" width="523" height="125" loading="lazy")
        img(v-else :src="$getImageUrl(promoImage.image.key, promoImage.image.filename)" alt="" width="523" height="125" loading="lazy")
</template>

<script>
export default {
    computed: {
        pData() {
            return this.$store.state.product.data
        },
    },
    methods: {
        urlTarget(url) {
            // Open PDF documents in new windows
            return url.substr(-3) === 'pdf' ? '_blank' : '_self'
        },
    },
}
</script>
